// extracted by mini-css-extract-plugin
export default {"root":"aFZLtwg7WBWXR_MhB5t7"};